import React from "react"
import { FloatingMenuContextProvider, useFloatingMenu } from "./context"
import FloatingMenuFab from "./floating_menu_fab"
import ProfileEditModal from "@love-irish/community-profile-edit-modal"

interface FloatingMenuProviderProps {
  children: React.ReactNode
  renderActionMenu?: boolean
}

export function FloatingMenuProvider({
  children,
  renderActionMenu = true,
}: FloatingMenuProviderProps) {
  return (
    <FloatingMenuContextProvider>
      {children}
      {renderActionMenu && <FloatingMenuFab />}
      <ProfileEditModalWrapper />
    </FloatingMenuContextProvider>
  )
}

function ProfileEditModalWrapper() {
  const { isProfileEditModalOpen, closeProfileEditModal } = useFloatingMenu()

  return (
    <ProfileEditModal
      open={isProfileEditModalOpen}
      onOpenChange={(open) => {
        if (!open) {
          closeProfileEditModal()
        }
      }}
    />
  )
}

// Re-export the hook for use in other components
export { useFloatingMenu } from "./context"

export default FloatingMenuProvider
